var React = require('react');

function SpotifyInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12 0C5.373 0 0 5.373 0 12c0 6.628 5.373 12 12 12 6.628 0 12-5.372 12-12 0-6.627-5.372-12-12-12Zm5.503 17.308a.748.748 0 0 1-1.029.248c-2.817-1.721-6.364-2.111-10.541-1.157A.748.748 0 0 1 5.6 14.94c4.571-1.044 8.492-.594 11.655 1.339a.748.748 0 0 1 .248 1.029Zm1.469-3.268a.936.936 0 0 1-1.287.309c-3.226-1.983-8.142-2.557-11.958-1.399a.937.937 0 0 1-1.167-.623.937.937 0 0 1 .624-1.167c4.358-1.322 9.776-.682 13.48 1.594.44.271.579.847.308 1.287Zm.126-3.402C15.23 8.34 8.85 8.129 5.157 9.25a1.122 1.122 0 1 1-.652-2.148c4.24-1.287 11.286-1.038 15.739 1.605a1.121 1.121 0 1 1-1.145 1.93h-.001Z","fill":"currentColor"}));
}

SpotifyInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = SpotifyInline;

SpotifyInline.default = SpotifyInline;
